import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

class DashboardBookings extends React.Component{

    state = {
        accordion: {}
    }

    toggleAccordion = (id) => {
        const accordion = {...this.state.accordion};
        if( accordion[id] !== 'undefined' && accordion[id] !== undefined ){
            accordion[id] = !accordion[id];
        }
        else {
            accordion[id] = true;
        }
        this.setState({ accordion });
    };

    render() {
        // const user = this.props.user;
        // const qArray = user._ReadingsQuestionnaire ? user._ReadingsQuestionnaire.split('\n') : [];
        return (
            <div className="tab-panel bookings">
                 <div className="accordion">
                {
                  this.props.appts
                    .sort((a, b) => {
                                const momentA = moment(a.ActionDate, "YYYYMMDDTHH:mm:ss");
                                const momentB = moment(b.ActionDate, "YYYYMMDDTHH:mm:ss");
                                return momentB.isBefore(momentA);
                            })
                    .map(appt => {
                        const des = appt.ActionDescription.toLowerCase();
                        if(des.indexOf('discovery session') !== -1 || des.indexOf('soul plan session') !== -1 || des.indexOf('rebook previous clients') !== -1){
                            return null;
                        }
                        let notes = {};
                        let location = '';
                        let id = '';
                        if(appt.CreationNotes && appt.CreationNotes.indexOf('{') === 0){
                            notes = JSON.parse(appt.CreationNotes);
                            if(notes.acuityId){
                                id = String(notes.acuityId);
                            }
                            if(notes.location && notes.location.indexOf('ID:') !== -1){
                                location = notes.location.substring( 4, notes.location.indexOf('Meeting ID:') - 1 );
                            }
                        }

                        const questionnaireLink = `https://bookings.intuitive-sensitives.com/questionnaire?email=${this.props.user.Email}&id=${id}`;
                        const showQlink = moment(appt.ActionDate, 'YYYYMMDDTHH:mm:ss').isSameOrAfter( moment(), 'day' );

                        const rescheduleLink = `https://bookings.intuitive-sensitives.com/?mode=reschedule&email=${this.props.user.Email}&id=${id}`;
                        const showRlink = moment(appt.ActionDate, 'YYYYMMDDTHH:mm:ss').isSameOrAfter( moment(), 'day' );

                        return (
                            <div key={appt.Id} className={ this.state.accordion[appt.Id] ? "accordionElement open" : "accordionElement"}>
                                <div className="accordionTitle flex-between" onClick={e => { this.toggleAccordion(appt.Id) } }>
                                    <div>
                                        <span>{ appt.ActionDescription }</span>
                                        <span className="date">{ moment(appt.ActionDate, 'YYYYMMDDTHH:mm:ss').format('ddd Do MMM YYYY - h:mma') }</span>
                                    </div>
                                    <i className="material-icons">expand_more</i>
                                </div>
                                <div className="accordionBody">
                                    <div className="accordionMeta">
                                        <label>UK time</label>
                                        <span>{moment(appt.ActionDate, 'YYYYMMDDTHH:mm:ss').format('ddd Do MMM YYYY - h:mma') }</span>
                                    </div>

                                    <div className="accordionMeta">
                                        <label>User's local time</label>
                                        <span>{ notes.localTime ? moment.parseZone(notes.localTime).format("ddd Do MMM YYYY - h:mma") : '' }</span>
                                    </div>

                                    <div className="accordionMeta">
                                        <label>User's timezone</label>
                                        <span>{ notes.timezone ? notes.timezone : '' }</span>
                                    </div>

                                    <hr/>

                                    <div className={showQlink ? "accordionMeta" : "hidden"}>
                                        <a target="_blank" href={ questionnaireLink } className="btn btn-primary btn-icon"><i className="material-icons">assignment</i>Edit questionnaire</a>
                                    </div>

                                    <div className={showRlink ? "accordionMeta" : "hidden"}>
                                        <a target="_blank" href={ rescheduleLink } className="btn btn-primary btn-icon"><i className="material-icons">today</i>Reschedule</a>
                                    </div>

                                    <div className={ location ? "accordionMeta" : "hidden" }>
                                        <a target="_blank" href={ location } className="btn btn-primary btn-icon"><i className="material-icons">open_in_browser</i>Join session</a>
                                    </div>

                                    <div className="accordionMeta wide">
                                        <label>Questionnaire</label>
                                        <div className="well">
                                            { !notes.questionnaire ? '' : Object.keys(notes.questionnaire).map(q => {
                                                return ( <div key={ q }>
                                                    <div className="question">{notes.questionnaire[q].question}</div>
                                                    <div className="answer">{notes.questionnaire[q].answer}</div>
                                                </div> );
                                            }) }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    }).reverse()
                }
                </div>
            </div>
        );
    }
}

DashboardBookings.propTypes = {
    user: PropTypes.object.isRequired
}

export default DashboardBookings;


/** WEBPACK FOOTER **
 ** ./src/components/DashboardBookings.js
 **/